/**
 * Labstep
 *
 * @module components/Notification/SideMenu
 * @desc Notification side menu
 */

import { NotificationListPreview as NotificationsPreviewList } from 'labstep-web/components/Notification/List/Preview';
import SideMenu from 'labstep-web/core/SideMenu';
import type React from 'react';
import styles from './styles.module.scss';
import type { NotificationSideMenuProps } from './types';

export const NotificationSideMenu: React.FC<
  NotificationSideMenuProps
> = ({ viewComponent }) => (
  <SideMenu viewComponent={viewComponent} name="notification">
    <div className={styles.container}>
      <div className={styles.notificationsContainer}>
        <NotificationsPreviewList />
      </div>
    </div>
  </SideMenu>
);
